import React from 'react';
import { connect } from "react-redux";
import style from './Properties.module.scss';
import {Row, Container, Col, OverlayTrigger, Tooltip, Form, Carousel} from "react-bootstrap";
import { numberWithCommas, timeAgo, getFilterName } from '../../../../helper/functions';
import * as propertyActions from "../../../../redux/action/property.action";
import history from "../../../../helper/history";
import * as regionActions from "../../../../redux/action/region.action";
import {BASE_URL} from "../../../../environment/environment";
import * as urls from "../../../../config/urls";
import noImage from "../../../../asset/images/icon/no-image-icon.png";
import transactionTypes from '../../../../asset/data/transactionTypes';
import propertyTypes from '../../../../asset/data/propertyTypes';

class Properties extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      selectedRegions: [],
    };
  }

  componentWillReceiveProps(nextProps, nextContext) {
    const {filter, regions = []} = nextProps;
    const selectedRegionsId = filter.region.split(',');

    const selectedRegions = regions.filter((el) => {
      return selectedRegionsId.some((f) => {
        return f === el.id;
      });
    });
    this.setState({selectedRegions});
  }

  selectProperty(item) {
    const paths = getFilterName();
    history.push(`/${paths[0]}/${item.id}${history.location.search}`);
  }

  render() {
    const {properties, propertiesCount, sort} = this.props;
    const {selectedRegions} = this.state;

    return (
      <div>
        <Container fluid className={`${style.properties_container}`}>
          <Row className={`d-flex justify-content-between no-gutters ${style.header}`}>
            <Col xs={'auto'}>
              <OverlayTrigger
                  key={'overlay'}
                  placement={'top'}
                  overlay={
                    <Tooltip id={`tooltip-overlay`}>
                      {
                        selectedRegions.map((selectedRegion, index) => {
                          return (<span>{selectedRegion.title}{index !== selectedRegions.length - 1 ? '، ': ''}</span>)
                        })
                      }
                    </Tooltip>
                  }>
                <span className={style.region_title}>تهران، &nbsp;
                  {
                    selectedRegions.map((selectedRegion, index) => {
                      return (
                          index <= 1 && <span>{selectedRegion.title}{index !== selectedRegions.length - 1 ? '، ': ''}</span>
                      );
                    })
                  }
                  {
                    selectedRegions.length > 2 && (
                        <span> ...</span>
                    )
                  }
                </span>
              </OverlayTrigger>
              <span className={`mr-3 ${style.total_count}`}>{propertiesCount} مورد فایل پیدا شد</span>
            </Col>
            <Col xs={12} lg={'auto'}>
              <div>
                <Form.Control as="select" value={sort} className={`custom-select pl-4`} onChange={(e) => {this.props.setSort(e.target.value)}}>
                  <option value={''} disabled selected hidden>مرتب سازی لیست</option>
                  <option value={'+overallPrice'}>ارزانترین</option>
                  <option value={'-overallPrice'}>گرانترین</option>
                  <option value={'-changedDate'}>جدیدترین</option>
                  <option value={'+changedDate'}>قدیمی ترین</option>
                </Form.Control>
              </div>
            </Col>
          </Row>
          <Row className={`p-0 justify-content-start`}>
            {
              properties.map((item, index) => {
                return <Col key={index} className={`mb-4 ${style.property_boxContainer}`} onClick={() => {
                  this.selectProperty(item);
                }}>
                  <div className={`${style.property_box}`}>
                    <div className={`${style.property_img}`}>
                      {
                        item.files && item.files.length ? (
                            <Carousel className={style.carousel} indicators={false} controls={item.files.length > 1}>
                              {
                                item.files.map((file, index) => {
                                  return (
                                    <Carousel.Item key={index}>
                                      <img className={`d-block w-100 ${style.property_carousel_image}`}
                                           src={`${BASE_URL}${urls.FILE_BY_UUID}/${file}?size=thumbnails`}
                                           alt="file"
                                      />
                                    </Carousel.Item>
                                  )
                                })
                              }
                            </Carousel>
                        ) : (
                            <img className={style.property_image} src={noImage} alt="file" />
                        )
                      }
                      <div className={`${style.property_situation}`}>
                        <span>{propertyTypes.find((tt) => tt.value === item.propertyType).label}</span>
                        &nbsp;
                        <span>{transactionTypes.find((tt) => tt.value === item.transactionType).label}</span>
                      </div>
                      {
                        item.propertyCode && (
                            <div className={`${style.property_code}`}>
                              <span>{item.propertyCode}</span>
                            </div>
                        )
                      }
                    </div>

                    <div className={`pr-3 pl-3 ${style.content_container}`}>
                      <div className={`${style.property_title} d-flex justify-content-between align-items-center`}>
                        <span>{item.propertyName}</span>
                        {/*<i className={'icon-bookmark-empty'} />*/}
                      </div>
                      <div className={`d-flex flex-column justify-content-between ${style.property_details}`}>
                        <div className={'d-flex align-items-center'}>
                          <i className={'icon-meter'} />
                          <span>متراژ:</span>
                          <span className={`${style.value}`}>{item.foundation} متر</span>
                        </div>
                        <div className={'d-flex align-items-center'}>
                          <i className={'icon-beds'} />
                          <span>تعداد خواب:</span>
                          <span className={`${style.value}`}>{item.propertyBedrooms ? item.propertyBedrooms : '-'}</span>
                        </div>
                        <div className={'d-flex align-items-center'}>
                          <i className={'icon-pin'} />
                          <span>{item.address || 'آدرس وارد نشده است'}</span>
                        </div>
                        <div className={'d-flex align-items-center'}>
                          <i className={'icon-avatar'} />
                          <span>{(item.advisors && item.advisors.length && `${item.advisors[0].alias}`) || '-----'}</span>
                        </div>
                      </div>
                      <div className={`${style.property_footer}`}>
                        <div className={'d-flex justify-content-between'}>
                          <span>قیمت:</span>
                          <span>
                            <span className={`${style.property_price}`}>{item.overallPrice ? numberWithCommas(item.overallPrice) : 'توافقی'} </span>
                            {item.overallPrice ? 'تومان' : ''}
                          </span>
                        </div>
                        <div>
                          <span>{timeAgo(item.changedDate)}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </Col>
              })
            }
          </Row>
        </Container>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  filter: state.property.filter,
  sort: state.property.filter.sort,
  listLoading: state.property.loading.list,
  properties: state.property.properties,
  regions: state.region.regions,
  propertiesCount: state.property.propertiesCount
});

const mapDispatchToProps = (dispatch) => ({
  setSelectedProperty: (property) => dispatch(propertyActions.setSelectedProperty(property)),
  findRegionByState: (state) => dispatch(regionActions.findRegionByState(state)),
  setSort: (sort) => dispatch(propertyActions.setSort(sort)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Properties);
